module.exports = __webpack_public_path__ + "img/chevron-down-regular.2775922b.svg";